import { Instance, SnapshotIn, types } from "mobx-state-tree";
import { withSetPropAction } from "mobx-stores/_extension/with-set-props";
import { Base, IBase } from "mobx-stores/_models/base";
import { Material } from "../material";

export const MaterialGoodsReceiptItem = types
  .compose(
    Base,
    types.model({
      materialId: types.maybeNull(types.string),
      material: types.maybeNull(Material),
      amount: types.maybeNull(types.number),
      wareHouse: types.maybeNull(types.string),
      brand: types.maybeNull(types.string),
      unitOfCalculation: types.maybeNull(types.string),
      code: types.maybeNull(types.string),
      origin: types.maybeNull(types.string),
      supplier: types.maybeNull(types.string),
      document: types.maybeNull(types.string),
      note: types.maybeNull(types.string),
    })
  )
  .actions(withSetPropAction);
export interface IMaterialGoodsReceiptItem
  extends Instance<typeof MaterialGoodsReceiptItem> {}
export interface IMaterialGoodsReceiptItemProperties
  extends SnapshotIn<typeof MaterialGoodsReceiptItem> {}

export interface IAddMaterialGoodsReceiptItem
  extends Omit<IMaterialGoodsReceiptItemProperties, "material" | keyof IBase> {}

export interface IUpdateMaterialGoodsReceiptItem
  extends Omit<IMaterialGoodsReceiptItemProperties, "material"> {}
